"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationAction = exports.useConfirmation = exports.Confirmation = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var EnhanceChildren_1 = require("../../enhance-children/EnhanceChildren");
var UI_1 = require("../UI");
exports.Confirmation = function (_a) {
    var callback = _a.callback, children = _a.children, title = _a.title;
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null, title || t('Confirm ?')),
        react_1.default.createElement("div", null, children),
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { onClick: function () { return callback(false); } },
                t('Cancel'),
                " "),
            react_1.default.createElement("button", { onClick: function () { return callback(true); } }, t('OK')))));
};
function useConfirmation(_a) {
    var Component = _a.Component, callback = _a.callback, props = tslib_1.__rest(_a, ["Component", "callback"]);
    var _b = tslib_1.__read(react_1.useState(false), 2), confirmation = _b[0], setConfirmation = _b[1];
    var confirmCallback = function (confirm) {
        setConfirmation(false);
        callback(confirm);
    };
    return {
        confirmation: react_1.default.createElement(react_1.default.Fragment, null, confirmation && react_1.default.createElement(Component, tslib_1.__assign({ callback: confirmCallback }, props))),
        setConfirmation: setConfirmation,
    };
}
exports.useConfirmation = useConfirmation;
function ConfirmationAction(props) {
    var _this = this;
    var _a = UI_1.useUIContext(), useLoader = _a.useLoader, useSuccessNotification = _a.useSuccessNotification, useErrorNotification = _a.useErrorNotification, useConfirmation = _a.useConfirmation;
    var _b = useLoader({}), loader = _b.loader, isLoading = _b.isLoading, setLoading = _b.setLoading;
    var _c = useSuccessNotification({
        title: props.title,
    }), successNotification = _c.successNotification, setSuccessNotification = _c.setSuccessNotification;
    var _d = useErrorNotification({ title: props.title }), errorNotification = _d.errorNotification, setErrorNotification = _d.setErrorNotification;
    var onSuccess = props.onSuccess;
    var _e = tslib_1.__read(react_1.useState(), 2), success = _e[0], setSuccess = _e[1];
    react_1.useEffect(function () {
        if (success && onSuccess) {
            setSuccess(undefined);
            onSuccess(success);
        }
    }, [success, onSuccess]);
    var _f = useConfirmation({
        title: props.title,
        children: props.confirmationMessage,
        callback: function (confirm) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm) {
                            setSuccessNotification(undefined);
                            setSuccess(undefined);
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.onConfirm()];
                    case 2:
                        data = _a.sent();
                        setLoading(false);
                        setErrorNotification(undefined);
                        setSuccessNotification(props.successMessage);
                        setSuccess(data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setLoading(false);
                        setSuccessNotification(undefined);
                        setErrorNotification(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
    }), confirmation = _f.confirmation, setConfirmation = _f.setConfirmation;
    var onClick = function () {
        setErrorNotification(undefined);
        setSuccessNotification(undefined);
        setSuccess(undefined);
        setConfirmation(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EnhanceChildren_1.EnhanceChildren, { children: props.children, enhance: { onClick: onClick, disabled: isLoading } }),
        successNotification,
        errorNotification,
        confirmation,
        loader));
}
exports.ConfirmationAction = ConfirmationAction;
//# sourceMappingURL=Confirmation.js.map